<script>
  import View from '@/views/View'
  import LoadSections from '@/mixins/load-sections'
  export default {
    name: 'PreReport',
    metaInfo: { title: 'Validasi Produk | Website Resmi Fitsea' },
    extends: View,
    mixins: [
      LoadSections([
        'preReport',
      ]),
    ],
    props: {
      id: {
        type: String,
        default: 'home',
      },
    },
  }
</script>
